interface SurveySparrowConfig {
    token: string;
    surveyName: string;
}

export const extractSurveySparrowConfig = (content: string): SurveySparrowConfig | null => {
    if (!content) return null;

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const configDiv = doc.querySelector('[data-ss-widget-token]');

    if (!configDiv) return null;

    const token = configDiv.getAttribute('data-ss-widget-token');
    const surveyName = configDiv.getAttribute('data-ss-survey-name');

    if (!token || !surveyName) return null;

    return {
        token,
        surveyName,
    };
};

export const loadSurveySparrow = (config: SurveySparrowConfig): void => {
    if (document.getElementById('SS_SCRIPT')) {
        return;
    }

    const win = window as any;
    const doc = document;
    const localStorage = win.localStorage;

    win.SS_WIDGET_TOKEN = config.token;
    win.SS_ACCOUNT = 'dreamlines.surveysparrow.com';
    win.SS_SURVEY_NAME = config.surveyName;

    const sparrowLaunch = (opts: any) => {
        const scriptId = 'ss-widget';
        const removedKey = `removed-ss-widget-${win.SS_WIDGET_TOKEN}`;

        if (!doc.getElementById(scriptId) && !localStorage.getItem(removedKey)) {
            const SparrowLauncher: any = function () {
                SparrowLauncher.update(arguments);
            };
            SparrowLauncher.args = [];
            SparrowLauncher.update = function (args: any) {
                SparrowLauncher.args.push(args);
            };
            win.SparrowLauncher = SparrowLauncher;

            const scriptElement = doc.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.id = scriptId;
            scriptElement.src = `https://${win.SS_ACCOUNT}/widget/${
                win.SS_WIDGET_TOKEN
            }?customParams=${JSON.stringify(opts)}`;

            const ssScriptElement = doc.getElementById('SS_SCRIPT');
            if (ssScriptElement?.parentNode) {
                ssScriptElement.parentNode.insertBefore(scriptElement, ssScriptElement);
                win.SS_VARIABLES = opts;
                ssScriptElement.parentNode.removeChild(ssScriptElement);
            }
        }
    };

    const ssScript = doc.createElement('script');
    ssScript.id = 'SS_SCRIPT';
    doc.body.appendChild(ssScript);

    sparrowLaunch({});
};

